/* eslint-env browser */

import * as React from 'react';
// @ts-ignore
import DeckGL from '@deck.gl/react';
import { EditableGeoJsonLayer } from '@nebula.gl/layers';
import { MeasureDistanceMode } from '@nebula.gl/edit-modes';
import {_MapContext as MapContext} from 'react-map-gl';
import {IViewPort} from "../store/types";

export function MeasurementLayer ({viewport}: {viewport: IViewPort}) {
    const [selectedFeatureIndexes] = React.useState([]);
    // @ts-ignore
    const [mode] = React.useState(() => MeasureDistanceMode);
    const [units, setUnits] = React.useState('feet');
    const checkUnits = React.useCallback((distance) => {
        if (units === 'feet' && distance > 5280) {
            setUnits('miles');
        }
        if (units === 'miles' && distance < 1) {
            setUnits('feet');
        }
    }, [units, setUnits]);
    const modeConfig = React.useMemo(() => {
        return {
            turfOptions: {units},
            measurementCallback: checkUnits
        }
    }, [units, checkUnits])

    const viewState = React.useMemo(() => {
        const {longitude, latitude, zoom} = viewport;
        return {longitude, latitude, zoom};
    }, [viewport]);

    // @ts-ignore
    const layer = React.useMemo(() => new EditableGeoJsonLayer({
        mode,
        modeConfig,
        selectedFeatureIndexes,
        _subLayerProps: {
            geojson: {},
            tooltips: {
                backgroundColor: [255,255,255],
                getPixelOffset: [0,-40],
            }
        },
    } as any), [mode, modeConfig, selectedFeatureIndexes]);

    // @ts-ignore
    return (
        <>
            <DeckGL
                ContextProvider={MapContext.Provider}
                width={'100%'}
                height={'100%'}
                viewState={viewState}
                controller={{
                    doubleClickZoom: false,
                } as any}
                layers={[layer]}
                getCursor={layer.getCursor.bind(layer)}
            >
            </DeckGL>
        </>
    );
}
